import { TFunction } from 'i18next';
import {
    ScheduledDashboardEmailRecipient,
    ScheduledDashboardEmail,
} from './types';
import { getTodayDateString } from 'components/inputs/dateHelpers';

export const shouldSendEmailRightAway = (
    email: ScheduledDashboardEmail,
): boolean => email.firstSentDate === getTodayDateString();

export const getEmailFromRecipient = (
    recipient: ScheduledDashboardEmailRecipient,
): string => recipient.externalEmail ?? recipient.internalEmail ?? '';

export const removeTime = (date: Date) => {
    const newDate = new Date(date);
    newDate.setHours(0, 0, 0, 0);
    return newDate;
};

export const getRecurrenceOptions = (isEditing: boolean, t: TFunction) => {
    const options = [];

    if (!isEditing) {
        options.push({
            value: 'once',
            label: t('sendDashboard.schedulingOnce'),
        });
    }

    return options.concat([
        { value: 'daily', label: t('sendDashboard.schedulingDaily') },
        { value: 'weekly', label: t('sendDashboard.schedulingWeekly') },
        { value: 'monthly', label: t('sendDashboard.schedulingMonthly') },
        { value: 'quarterly', label: t('sendDashboard.schedulingQuarterly') },
    ]);
};
